var LayoutPerspective = require('./../layout/LayoutPerspective');
var paymentPerspectiveTemplate = require('./paymentPerspectiveTemplate.hbs');
var MakePaymentWidget = require('./MakePaymentWidget');
var WizardAccessBehavior = require('./../wizard/WizardAccessBehavior');
var WizardPerspectiveBehavior = require('./../wizard/WizardPerspectiveBehavior');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var wizardUtils = require('./../wizard/wizardUtils');

/**
 * Perspective to display the Make Payment page
 *
 * @class PaymentPerspective
 * @param options {Object} Options to configure this perspective.
 * @param [options.patientVecnaId] {String} the vecna id of the current patient
 * @param [options.appointmentExternalId] {String} the external id of the current appointment
 */
module.exports = LayoutPerspective.extend({
  template: paymentPerspectiveTemplate,
  moduleNamespace: 'paymentPerspective',

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: function() {
        if (this.isInPreReg) {
          return 'appointment.bill.aside.header';
        } else {
          return 'bill.aside.header';
        }
      },
      asideContentMessageKey:  function() {
        if (this.isInPreReg) {
          return 'appointment.bill.aside';
        } else {
          return 'bill.aside';
        }
      }
    },
    wizardAccessBehavior: WizardAccessBehavior,
    wizardPerspectiveBehavior: {
      behavior: WizardPerspectiveBehavior,
      pageName: WizardPerspectiveBehavior.PAGE_NAMES.PAYMENT,
      childPageName: WizardPerspectiveBehavior.PAGE_NAMES.PAYMENT_DETAIL
    },
    appointmentSecureMessage: {
      behavior: SecureMessageDataBehavior,
      returnSingleResult: true,
      ids: function(cache) {
        var appointmentExternalId = this.view._appointmentExternalId;
        if (!appointmentExternalId) {
          return { skipObjectRetrieval: true };
        }

        var patientVecnaId = this.view._patientVecnaId;
        var criteria = cache.getCriteriaForAppointmentIdAndExternalId(patientVecnaId, appointmentExternalId);
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: { property: 'behaviors.appointmentSecureMessage.data:appointmentDTO.externalAppointment.type'}
    }
  },

  prepareFields: {
    billId: '_billId'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param [options.regDate] {String} the date of the appointments
   *   @param [options.billId] {Number} the id of the bill to display.
   *   @param [options.moduleNamespace] {String} the message key prefix to use.
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    options = options || {};


    // These are set for the wizard behaviors.
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;

    this.moduleNamespace = options.moduleNamespace;

    var isInPreReg = false;

    if (this._appointmentExternalId || this._regDate) {
      isInPreReg = true;
      this._appointmentExternalIds =
          wizardUtils.getSelectedPreRegWizardAppointmentExternalIds(this._appointmentExternalId, this._regDate);
    }

    if (options.patientVecnaId) {
      this._patientVecnaId = options.patientVecnaId;
    }

    if (options.billId) {
      this._billId = options.billId;
      isInPreReg = false;
    }

    this._isInPreReg = isInPreReg;
    this.getBehavior('asideBehavior').isInPreReg = isInPreReg;
    this.getBehavior('wizardPerspectiveBehavior').isActive = isInPreReg;
  },

  /**
   * Generates a fresh version of the payment widget to remove any old data.
   * @method clearPaymentWidget
   */
  clearPaymentWidget: function() {
    if (this._makePaymentWidget) {
      this.stopListening(this._makePaymentWidget, 'markPreRegCompleted');
      this.unregisterTrackedView(this._makePaymentWidget);
    }

    this._makePaymentWidget = new MakePaymentWidget({
      isInPreReg: this._isInPreReg,
      patientVecnaId: this._patientVecnaId,
      appointmentExternalIds: this._appointmentExternalIds,
      billId: this._billId
    });
    this.getBehavior('wizardPerspectiveBehavior').setContentView(this._makePaymentWidget);

    this.listenTo(this._makePaymentWidget, 'markPreRegCompleted', this._markPreRegCompleted);
  },

  /**
   * @method _markPreRegCompleted
   * @private
     */
  _markPreRegCompleted: function() {
    var wizardWidget = this.getBehavior('wizardPerspectiveBehavior').getWizardWidget();
    wizardWidget.markStepCompleted()
      .then(wizardWidget.completeWizardWorkflow)
      .then(function(url) {
        window.location.assign(url);
      });
  }
});
